import { render, staticRenderFns } from "./customerOverview.vue?vue&type=template&id=310ff548&"
import script from "./customerOverview.vue?vue&type=script&lang=js&"
export * from "./customerOverview.vue?vue&type=script&lang=js&"
import style0 from "./customerOverview.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports